import { render, staticRenderFns } from "./CompanyLayoutVertical.vue?vue&type=template&id=77389a56&"
import script from "./CompanyLayoutVertical.vue?vue&type=script&lang=js&"
export * from "./CompanyLayoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLayoutVertical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports